import { ImageSectionColumnsInfo, ImageWithTextSection } from '@quicktools/shared-components';
import IImageWithTextSection from '@quicktools/shared-components/components/landingPages/ImageWithTextSection/types';
import { useTranslation } from 'react-i18next';

function ImageSections() {
  const { t } = useTranslation();

  const texts = t('landing.imageSection', { returnObjects: true }) as IImageWithTextSection[];

  let imageSectionItems: IImageWithTextSection[] = [
    {
      imageWidth: 464,
      imgSrc: 'https://cdn140.picsart.com/72694943745200280056.webp',
      imgAlt: 'All Symbols',
      imageRight: true,
    },
    {
      imageWidth: 464,
      imgSrc: 'https://cdn140.picsart.com/84080601532174147890.webp',
      imgAlt: 'Symbols',
    },
    {
      imageWidth: 370,
      imgSrc: 'https://cdn140.picsart.com/09521424561190409142.webp',
      imgAlt: 'Symbols',
      imageRight: true,
    },
  ];

  imageSectionItems = imageSectionItems.map((section, i) => ({ ...section, ...texts[i] }));

  return (
    <>
      {imageSectionItems.map(({ columns, ...sectionProps }, i) => (
        <ImageWithTextSection key={i} {...sectionProps}>
          {columns && <ImageSectionColumnsInfo columns={columns} />}
        </ImageWithTextSection>
      ))}
    </>
  );
}

export default ImageSections;
